export enum InvoiceCatImpuesto {
  'ISR' = '001',
  'IVA' = '002',
  'IEPS' = '003',
}
